import store from '@/store';

export default (to, from, next) => ({
    allow: store.getters.is_sims_multi_plans_allowed,
    redirect: { name: 'not-found' },
})